export enum BusinessTypeActionType {
    GETTING_BUSINESS_TYPE = 'GETTING_BUSINESS_TYPE',
    GETTING_BUSINESS_TYPE_SUCCESS = 'GETTING_BUSINESS_TYPE_SUCCESS',
    GETTING_BUSINESS_TYPE_FAILURE = 'GETTING_BUSINESS_TYPE_FAILURE'
}
